import { useEffect, useState } from "react";
import { getCityName, getCountryName, getStateName } from "./helperFunction";

const GetAddress = ({address,color=""})=>{

    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [country, setCountry] = useState("");

    const fetchAddressDetails = async () => {
      if (address) {
          const cityValue = await getCityName(address.ctr, address.st, address.ct);
          const stateValue = await getStateName(address.ctr, address.st);
          const countryValue = await getCountryName(address.ctr, address.st);

          setCity(cityValue);
          setState(stateValue);
          setCountry(countryValue);
      }
  };

  useEffect(() => {
      fetchAddressDetails();
  }, [address]);

    return (
        <>
            {address?.s1 && <p style={{color:color}}>{address?.s1}</p>}
            {address?.s2 && <p style={{color:color}}>{address?.s2}</p>}
            <p style={{color:color}}>{city ? `${city},` : ""}{state}</p>
            <p style={{color:color}}>{country ? country : ""}{address?.pin ? `,${address?.pin}` : ""}</p>
        </>
    )
}

export default GetAddress;